import { useEffect } from "react";

import { initializeGoogleTagManager } from "../../../integrations/googleTagManager";
import { loadAmpli } from "../../../integrations/amplitude";
import { loadWalkMe } from "../../../integrations/walkme";

interface UseUserIntegrationsParams {
  loginId?: string;
  storeId?: string;
  storeName?: string;
  enterpriseId?: string;
  enterpriseName?: string;
}

export const useUserIntegrations = ({
  loginId,
  storeId,
  storeName,
  enterpriseId,
  enterpriseName,
}: UseUserIntegrationsParams): void => {
  useEffect(() => {
    if (!loginId || !storeId) {
      return;
    }

    initializeGoogleTagManager({
      loginId,
      storeId,
      storeName: storeName ?? "",
      enterpriseId: enterpriseId ?? "",
      enterpriseName: enterpriseName ?? "",
    });
  }, [loginId, storeId, storeName, enterpriseId, enterpriseName]);

  useEffect(() => {
    if (!loginId) {
      return;
    }

    loadWalkMe(loginId);
    loadAmpli(loginId);
  }, [loginId]);
};
